import {
  AlternateEmail,
  AssignmentInd,
  CalendarMonth,
  Flag,
  Forum,
  Group,
  NoMeals,
  Person,
  PhoneIphone,
  Restaurant,
  School,
  UploadFile,
  Work,
} from "@mui/icons-material";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Collapse,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { useEffect, useState } from "react";
import { registerUser, getCountries, rollBack } from "../api/api";
import { format, isValid } from "date-fns";

const Inscripcion = () => {
  // Hooks


  const textInitialState = {
    value: '',
    error: false
  }

  const dateInitialState = {
    value: null,
    error: false
  }

  const selectInitialState = {
    value: '-1',
    error: false
  }

  const requiredInitialState = [
    "name",
    "id",
    "date",
    "country",
    "email",
    "role",
    "menu",
  ]

  const [missingRequiredFields, setMissingRequiredFields] = useState(requiredInitialState);

  const [name, setName] = useState(textInitialState);
  const [id, setID] = useState(textInitialState);
  const [date, setDate] = useState(dateInitialState);
  const [gender, setGender] = useState("0");
  const [country, setCountry] = useState(selectInitialState);
  const [profession, setProfession] = useState('');
  const [email, setEmail] = useState(textInitialState);
  const [emailAlt, setEmailAlt] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState(selectInitialState);
  const [student, setStudent] = useState(selectInitialState);
  const [menu, setMenu] = useState(selectInitialState);
  const [alergyInd, setAlergyInd] = useState("No");
  const [alergy, setAlergy] = useState(textInitialState);
  const [processing, setProcessing] = useState(false)
  const [messages, setMessages] = useState({ status: 0, message: "" });

  const [countries, setCountries] = useState([]);

  // Functions

  const changeField = (field, value, defaultValue, method) => {
    const error = value === defaultValue;


    if (!error) {
      setMissingRequiredFields((prev) => prev.filter((x) => x !== field));
    } else {
      if (!missingRequiredFields.includes(field))
        setMissingRequiredFields((prev) => [...prev, field]);
    }

    method({ value: value, error: error });
  };

  const clearFields = () => {
    setName(textInitialState);
    setID(textInitialState);
    setDate(dateInitialState);
    setGender("0");
    setCountry(selectInitialState);
    setProfession("");
    setEmail(textInitialState);
    setEmailAlt("");
    setPhone("");
    setRole(selectInitialState);
    setStudent(selectInitialState);
    setMenu(selectInitialState);
    setAlergyInd("No");
    setAlergy(textInitialState);
    setMissingRequiredFields(requiredInitialState);
  };

  const saveForm = async () => {
    let response = { status: 0, message: "" };

    const jsonData = JSON.stringify({
      user_name: name.value,
      user_id: id.value,
      user_dob: date.value,
      user_gender: gender,
      user_country: country.value,
      user_profession: profession,
      user_email: email.value,
      user_alt_email: emailAlt,
      user_phone: phone,
      user_role: role.value,
      user_student: student.value,
      user_menu: menu.value,
      user_alergy_flag: alergyInd,
      user_alergy: alergy.value,
    });

    setProcessing(true);

    // Create user record in realtime DB
    response = await registerUser(jsonData);

    if (response.status === 200) {
      clearFields();
    }

    setProcessing(false);
    setMessages({ status: response.status, message: response.message });
  };

  const handleClose = () => {
    setMessages({ status: 0, message: "" });
  };

  useEffect(() => {

    const callGetCountries = async () => {
      const countryList = await getCountries();
      setCountries(
        countryList.map((x) => {
          return x.translations.spa.common;
        })
      );
    };

    callGetCountries();
  }, []);


  return (
    <>    
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={messages.message !== ""}
        onClose={handleClose}
      >
        <Alert
          variant="filled"
          severity={messages.status === 0 ? "" : messages.status === 200 ? "success" : "error"}
        >
          {messages.message}
        </Alert>
      </Snackbar>
      <Backdrop in={processing} sx={{ zIndex: 1300 }}>
        <Stack flexDirection='column' alignItems='center'>
          <CircularProgress sx={{ color: 'rgb(18,161,154)' }} />
          <Typography variant='subtitle1' sx={{ color: 'white' }}>
            Procesando
          </Typography>
        </Stack>
      </Backdrop>
      <Paper elevation={3}>
        <Box display="flex" flexDirection="column">
          <Box p={1} sx={{ background: '#9CCC60', color: 'white' }}>
            <Typography variant="h4" className="title">
              FORMULARIO DE INSCRIPCIÓN
            </Typography>
          </Box>
          <Grid
            container
            flexDirection="column"
            justifyContent="center"
            spacing={3}
          >
            <Grid item>
              <Box p={1}>
                <Typography variant="h3" className="subtitle">
                  Datos personales
                </Typography>
              </Box>
              <Box display="flex" p={1}>
                <Grid
                  id="personal"
                  container
                  flexDirection="row"
                  justifyContent="center"
                  spacing={3}
                >
                  <Grid item>
                    <Grid container flexDirection="column" spacing={6}>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <Person fontSize="small" />
                          <TextField
                            id="txt_nombre"
                            variant="outlined"
                            label="Nombre Completo"
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={name.value}
                            error={name.error}
                            onChange={(event) => changeField("name", event.target.value, "", setName)}
                            onBlur={() => {
                              setName({ value: name.value, error: name.value === "" });
                            }}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <AssignmentInd fontSize="small" />
                          <TextField
                            id="txt_id"
                            variant="outlined"
                            label="Número de identificación o pasaporte"
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={id.value}
                            error={id.error}
                            onChange={(event) => changeField("id", event.target.value, "", setID)}
                            onBlur={() => {
                              setID({ value: id.value, error: id.value === "" });
                            }}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <CalendarMonth fontSize="small" />
                          <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDateFns}>
                            <DatePicker
                              id="txt_dob"
                              variant="outlined"
                              label="Fecha de Nacimiento"
                              value={date.value}
                              onChange={(value) => changeField("date", value, null, setDate)}
                              renderInput={(params) => <TextField required sx={{ marginLeft: "8px" }} className="field" {...params} onBlur={() => {
                                setDate({ value: date.value, error: !isValid(date.value) });
                              }} error={date.error}
                              />}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <Group fontSize="small" />
                          <Select
                            id="ddl_genero"
                            displayEmpty
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={gender}
                            onChange={(event) => setGender(event.target.value)}
                          >
                            <MenuItem value={"0"}>
                              Seleccione su género
                            </MenuItem>
                            <MenuItem value="Femenino">Femenino</MenuItem>
                            <MenuItem value="Masculino">Masculino</MenuItem>
                            <MenuItem value="Otro">Otro</MenuItem>
                          </Select>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid container flexDirection="column" spacing={6}>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <Flag fontSize="small" />
                          <Select
                            id="ddl_pais"
                            displayEmpty
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={country.value}
                            error={country.error}
                            onChange={(event) => changeField("country", event.target.value, "-1", setCountry)}
                            onBlur={() => {
                              setCountry({ value: country.value, error: country.value === "-1" });
                            }}
                          >
                            <MenuItem value="-1">Seleccione su país</MenuItem>
                            {countries.sort().map((x, i) => (
                              <MenuItem key={i} value={x}>
                                {x}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>

                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <Work fontSize="small" />
                          <TextField
                            id="txt_profession"
                            variant="outlined"
                            label="Profesión"
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={profession}
                            onChange={(event) => setProfession(event.target.value)}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item>
              <Box p={1}>
                <Typography variant="h6" className="subtitle">
                  Datos de contacto
                </Typography>
              </Box>
              <Box display="flex" p={1}>
                <Grid
                  id="contacto"
                  container
                  flexDirection="row"
                  justifyContent="center"
                  spacing={3}
                >
                  <Grid item>
                    <Grid container flexDirection="column" spacing={2}>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <AlternateEmail fontSize="small" />
                          <TextField
                            id="txt_email"
                            variant="outlined"
                            label="Correo Electronico"
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={email.value}
                            error={email.error}
                            onChange={(event) => changeField("email", event.target.value, "", setEmail)}
                            onBlur={() => {
                              setEmail({ value: email.value, error: email.value === "" });
                            }}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <AlternateEmail fontSize="small" />
                          <TextField
                            id="txt_alt_email"
                            variant="outlined"
                            label="Correo Electronico Secundario"
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={emailAlt}
                            onChange={(event) => setEmailAlt(event.target.value)}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid container flexDirection="column" spacing={2}>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <PhoneIphone fontSize="small" />
                          <TextField
                            id="txt_telefono"
                            variant="outlined"
                            label="Teléfono"
                            sx={{ marginLeft: "8px" }}
                            className="field"
                            value={phone}
                            onChange={(event) => setPhone(event.target.value)}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid id="congreso" item>
              <Box p={1}>
                <Typography variant="h6" className="subtitle">
                  Datos para el congreso
                </Typography>
              </Box>
              <Box display="flex" p={1}>
                <Grid container flexDirection="column" spacing={3}>
                  <Grid item>
                    <Grid
                      container
                      flexDirection="row"
                      justifyContent="center"
                      spacing={3}
                    >
                      <Grid item>
                        <Grid container flexDirection="column" spacing={2}>
                          <Grid item>
                            <Box display="flex" alignItems="center">
                              <Forum fontSize="small" />
                              <Select
                                id="ddl_participacion"
                                displayEmpty
                                sx={{ marginLeft: "8px", minWidth: "232px" }}
                                className="field"
                                value={role.value}
                                error={role.error}
                                onChange={(event) => {
                                  const role = event.target.value;
                                  changeField("role", role, "-1", setRole);
                                  if (role.includes("Estudiante")) {
                                    setMissingRequiredFields((prev) => [...prev, "student"]);
                                  }
                                  else {
                                    setMissingRequiredFields((prev) => prev.filter((x) => x !== "student"));
                                    setStudent(selectInitialState);
                                  }
                                }}
                                onBlur={() => {
                                  setRole({ value: role.value, error: role.value === "-1" });
                                }}
                              >
                                <MenuItem value="-1">
                                  Seleccione su categoria de participación
                                </MenuItem>
                                <MenuItem value="Estudiante (Pregrado y grado)">
                                  Estudiante (Pregrado y grado)
                                </MenuItem>
                                <MenuItem value="Profesional">
                                  Profesional
                                </MenuItem>
                                <MenuItem value="Ponente Nacional">Ponente Nacional</MenuItem>
                                <MenuItem value="Ponente Extranjero">Ponente Extranjero</MenuItem>
                                <MenuItem value="Comision Directiva CICOP">Comisión Directiva CICOP</MenuItem>
                              </Select>
                            </Box>
                          </Grid>
                          {role.value.includes("Estudiante") && <Grid item>
                            <Box display="flex" alignItems="center">
                              <School fontSize="small" />
                              <Select
                                id="ddl_estudiante"
                                displayEmpty
                                sx={{ marginLeft: "8px", minWidth: "232px" }}
                                className="field"
                                value={student.value}
                                error={student.error}
                                onChange={(event) => changeField("student", event.target.value, "-1", setStudent)}
                                onBlur={() => {
                                  setStudent({ value: student.value, error: student.value === "-1" });
                                }}
                              >
                                <MenuItem value="-1">
                                  Seleccione su categoria de estudiante
                                </MenuItem>
                                <MenuItem value="Expositor (ponencia o poster)">
                                  Expositor (ponencia o poster)
                                </MenuItem>
                                <MenuItem value="Participante no expositor">
                                  Participante no expositor
                                </MenuItem>
                              </Select>
                            </Box>
                          </Grid>}
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid container flexDirection="column" spacing={2}>
                          <Grid item>
                            <Box display="flex" alignItems="center">
                              <Restaurant fontSize="small" />
                              <Select
                                id="ddl_menu"
                                displayEmpty
                                sx={{ marginLeft: "8px", minWidth: "232px" }}
                                className="field"
                                value={menu.value}
                                error={menu.error}
                                onChange={(event) => changeField("menu", event.target.value, "-1", setMenu)}
                                onBlur={() => {
                                  setMenu({ value: menu.value, error: menu.value === "-1" });
                                }}
                              >
                                <MenuItem value="-1">
                                  Seleccione su tipo de menu
                                </MenuItem>
                                <MenuItem value="Sin restricción">
                                  Sin restricción
                                </MenuItem>
                                <MenuItem value="Vegano">Vegano</MenuItem>
                                <MenuItem value="Vegetariano">
                                  Vegetariano
                                </MenuItem>
                                <MenuItem value="Libre de Gluten">
                                  Libre de Gluten
                                </MenuItem>
                              </Select>
                            </Box>
                          </Grid>
                          <Grid item>
                            <Grid container flexDirection="column" spacing={2}>
                              <Grid item>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label">
                                      Padece de alguna alergia hacia algún
                                      alimento?
                                    </FormLabel>
                                    <RadioGroup
                                      aria-labelledby="demo-radio-buttons-group-label"
                                      defaultValue="No"
                                      name="radio-buttons-group"
                                      row
                                      sx={{ justifyContent: "center" }}
                                      value={alergyInd}
                                      onChange={(event) => {
                                        const alergy = event.target.value;
                                        setAlergyInd(alergy)
                                        if (alergy === "Si") { setMissingRequiredFields((prev) => [...prev, "alergy"]); }
                                        else {
                                          setMissingRequiredFields((prev) => prev.filter((x) => x !== "alergy"));
                                          setAlergy(textInitialState);
                                        }
                                      }}
                                    >
                                      <FormControlLabel
                                        value="Si"
                                        control={
                                          <Radio
                                          />
                                        }
                                        label="Si"
                                      />
                                      <FormControlLabel
                                        value="No"
                                        control={
                                          <Radio
                                            inputProps={{ tabIndex: "14" }}
                                          />
                                        }
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Box>
                              </Grid>
                              {alergyInd === "Si" && (
                                <Grid item>
                                  <Box display="flex" alignItems="center">
                                    <NoMeals fontSize="small" />
                                    <TextField
                                      id="txt_alergy_food"
                                      variant="outlined"
                                      multiline
                                      label="Favor indique su restricción alimenticia"
                                      sx={{ marginLeft: "8px" }}
                                      className="field"
                                      value={alergy.value}
                                      error={alergy.error}
                                      onChange={(event) => changeField("alergy", event.target.value, "", setAlergy)}
                                      onBlur={() => {
                                        setAlergy({ value: alergy.value, error: alergy.value === "" });
                                      }}
                                    />
                                  </Box>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid id="footer" container item justifyContent="center">
              <Grid item>
                <Box display="flex" p={1}>
                  <Button
                    sx={{ background: "rgb(18,161,154)" }}
                    variant="contained"
                    onClick={clearFields}
                  >
                    Limpiar Formulario
                  </Button>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" p={1}>
                  <Button
                    disabled={missingRequiredFields.length > 0}
                    sx={{ background: "rgb(18,161,154)" }}
                    variant="contained"
                    onClick={saveForm}
                  >
                    Confirmar Inscripcion
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};

export default Inscripcion;
